import { useRef, useEffect } from "react";
import clsx from "clsx";

export default function HorizontalDragScroller({
  children,
  className = "",
  speed = 1.2,
  dragThreshold = 6,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasDragged = false;

    const onDown = (e) => {
      if (e.button !== 0) return;
      isDown = true;
      hasDragged = false;

      el.classList.add("dragging");
      startX = e.pageX;
      startScrollLeft = el.scrollLeft;

      document.body.style.userSelect = "none";
    };

    const onMove = (e) => {
      if (!isDown) return;
      e.preventDefault();

      const dx = e.pageX - startX;

      if (!hasDragged && Math.abs(dx) >= dragThreshold) {
        hasDragged = true;
      }

      if (hasDragged) {
        el.scrollLeft = startScrollLeft - dx * speed;
      }
    };

    const onUp = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("dragging");
      document.body.style.userSelect = "";
    };

    const onClickCapture = (e) => {
      if (!hasDragged) return;

      e.preventDefault();
      e.stopPropagation();

      hasDragged = false;
    };

    el.addEventListener("mousedown", onDown);
    window.addEventListener("mousemove", onMove, { passive: false });
    window.addEventListener("mouseup", onUp);

    el.addEventListener("click", onClickCapture, true);

    return () => {
      el.removeEventListener("mousedown", onDown);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      el.removeEventListener("click", onClickCapture, true);
      document.body.style.userSelect = "";
    };
  }, [speed, dragThreshold]);

  return (
    <div ref={ref} className={clsx("horizontal-drag-scroller", className)}>
      {children}
    </div>
  );
}
